import PropTypes from 'prop-types';

const LinkButton = ({
  onClick,
  children,
  href,
  target,
  ...property
}) => (
  <a href={href} onClick={onClick} className={`text-sm font-medium text-blue-700 ${property.className}`} target={target}>{children}</a>
);

export default LinkButton;

LinkButton.propTypes = {
  href: PropTypes.string,
  className: PropTypes.string,
  target: PropTypes.string,
  children: PropTypes.string
};
